import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _IconExpandSolid, _IconExpandLine, _IconArrowOpenDownLin, _IconArrowOpenUpLine;
// /*
//  * The MIT License (MIT)
//  *
//  * Copyright (c) 2015 - present Instructure, Inc.
//  *
//  * Permission is hereby granted, free of charge, to any person obtaining a copy
//  * of this software and associated documentation files (the "Software"), to deal
//  * in the Software without restriction, including without limitation the rights
//  * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
//  * copies of the Software, and to permit persons to whom the Software is
//  * furnished to do so, subject to the following conditions:
//  *
//  * The above copyright notice and this permission notice shall be included in all
//  * copies or substantial portions of the Software.
//  *
//  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
//  * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
//  * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
//  * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
//  * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
//  * SOFTWARE.
//  */
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IconExpandLine, IconExpandSolid, IconArrowOpenDownLine, IconArrowOpenUpLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { ScreenReaderContent, PresentationContent } from '@instructure/ui-a11y-content';
import { Drilldown } from '@instructure/ui-drilldown';
import { View } from '@instructure/ui-view';
import * as CaptureActions from '../../../actions';
import { translate } from '../../../constants/translated/translations';
const ON_VALUE = 'ON';
const OFF_VALUE = 'OFF';

/**
---
private: true
---
**/
function ScreenSharingControl({
  activateScreenSharing,
  deactivateScreenSharing,
  isDisabled,
  isActive,
  betaActionText = '',
  betaActionURL = '',
  mobile = false
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  const handleSelect = selected => {
    if (selected[0] === ON_VALUE) {
      activateScreenSharing();
    } else {
      deactivateScreenSharing();
    }
  };
  const mobileLabel = isActive ? translate('SCREEN_SHARING_CONTROL_LABEL_ACTIVATE') : translate('SCREEN_SHARING_CONTROL_LABEL_DEACTIVATE');
  return /*#__PURE__*/React.createElement(Drilldown, {
    withArrow: true,
    rootPageId: "media-capture-screen-capture-options-page",
    trigger:
    /*#__PURE__*/
    // className is needed for impact app
    React.createElement(View, {
      as: "span",
      className: "ScreenCapture-menu"
    }, /*#__PURE__*/React.createElement(Button, {
      display: "block",
      color: "primary-inverse",
      withBackground: true,
      size: "medium",
      "data-testid": "ScreenSharingControl",
      interaction: isDisabled ? 'disabled' : 'enabled',
      renderIcon: isActive ? _IconExpandSolid || (_IconExpandSolid = /*#__PURE__*/React.createElement(IconExpandSolid, null)) : _IconExpandLine || (_IconExpandLine = /*#__PURE__*/React.createElement(IconExpandLine, null)),
      themeOverride: {
        iconSizeMedium: '1.125rem'
      },
      "aria-expanded": isOpened
    }, mobile ? mobileLabel : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      padding: "0 x-small 0 0"
    }, translate('SCREEN_SHARING_CONTROL')), isOpened ? _IconArrowOpenDownLin || (_IconArrowOpenDownLin = /*#__PURE__*/React.createElement(IconArrowOpenDownLine, null)) : _IconArrowOpenUpLine || (_IconArrowOpenUpLine = /*#__PURE__*/React.createElement(IconArrowOpenUpLine, null))))),
    onToggle: (_, {
      shown
    }) => setIsOpened(shown),
    shouldHideOnSelect: true
  }, /*#__PURE__*/React.createElement(Drilldown.Page, {
    id: "media-capture-screen-capture-options-page",
    renderActionLabel: betaActionText,
    onHeaderActionClicked: () => {
      window.open(betaActionURL, '_blank');
    }
  }, /*#__PURE__*/React.createElement(Drilldown.Group, {
    id: "media-capture-screen-capture-options-group",
    selectableType: "single",
    onSelect: (_e, {
      value
    }) => {
      handleSelect(value);
    }
  }, /*#__PURE__*/React.createElement(Drilldown.Option, {
    id: "media-capture-screen-capture-on",
    key: "media-capture-screen-capture-on",
    value: ON_VALUE,
    selected: isActive
  }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, translate('SCREEN_SHARING_CONTROL_LABEL_ACTIVATE')), /*#__PURE__*/React.createElement(PresentationContent, null, translate('SCREEN_SHARING_CONTROL_ACTIVATE'))), /*#__PURE__*/React.createElement(Drilldown.Option, {
    id: "media-capture-screen-capture-off",
    key: "media-capture-screen-capture-off",
    value: OFF_VALUE,
    selected: !isActive
  }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, translate('SCREEN_SHARING_CONTROL_LABEL_DEACTIVATE')), /*#__PURE__*/React.createElement(PresentationContent, null, translate('SCREEN_SHARING_CONTROL_DEACTIVATE'))))));
}
const mapStateToProps = state => ({
  isActive: state.screenSharingActive
});
const mapDispatchToProps = dispatch => _objectSpread({}, bindActionCreators(CaptureActions, dispatch));
export default connect(mapStateToProps, mapDispatchToProps)(ScreenSharingControl);